import {
    Button, HorizontalSpacer, MainPageAccessor, SlideoutDecorator, SlideoutDecoratorBehavior
} from "@mcleod/components";

export class AppSlideoutDecoratorBehavior extends SlideoutDecoratorBehavior {
    protected constructor() {
        super();
    }

    public override addCloseButton(decorator: SlideoutDecorator, closeButton: Button): void {
        closeButton.setProps({ imageWidth: 24, imageHeight: 24, rowBreak: false });
        decorator.panelHeader.insert(closeButton, 0);
    }

    public performSlideIn(decorator: SlideoutDecorator): Promise<any> {
        decorator.fillHorizontalSpace = true;
        decorator.paddingBottom = 0;
        decorator.panelHeader.setProps({ paddingRight: 8, height: MainPageAccessor.pageHeaderHeight });

        // Technically, this is an example of the non-existent VerticalSpacer...
        // Need to push header information below the OS system tools (time, battery, wifi, etc.)
        decorator.panelHeader.insert(new HorizontalSpacer({ fillHeight: true, fillRow: false, rowBreak: true }), 0);

        decorator.overlayProps = { ...decorator.overlayProps, coverPageHeader: true };
        decorator.transitionOptions = { ...decorator.transitionOptions, paddingBottom: 0 };

        return super.performSlideIn(decorator);
    }
}

AppSlideoutDecoratorBehavior.register();
